import { endpoints } from "../../../configs/Settings";
import { useAxios } from "../../../utils/useAxios";
import { auxiliarData } from "../AuxiliarData";
import { HTTPResponseStatus } from "../../../utils/enum";
import { IRelatedPersonData } from "../../../utils/interfaces";
import { OAuthApplication } from "../../auth";

export async function PostRelatedPerson(
  objData: IRelatedPersonData,
  patientActor: { reference: string; display: string },
  status?: true | false,
  isVetSystem?: boolean
) {
  const url = `${endpoints.ADMFHIR}/RelatedPerson`;

  const bearerToken = await OAuthApplication();
  const data = auxiliarData.RelatedPerson(objData, patientActor, status);

  // Headers básicos
  const headers: any = {
    Accept: "application/fhir+json",
    Authorization: bearerToken,
    "Content-Type": "application/fhir+json",
  };

  // Adicionar header X-Target-System somente se isVetSystem for true
  if (isVetSystem) {
    headers["X-Target-System"] = "vet";
  }

  const response = await useAxios
    .post(url, data, { headers, timeout: 20000 })
    .then((response) => {
      if (
        response.status !== HTTPResponseStatus.Created &&
        response.status !== HTTPResponseStatus.Success
      ) {
        throw new Error(`PostRelatedPerson: ${response.status}`);
      }
      return { status: HTTPResponseStatus.Success, data: response.data };
    })
    .catch((error) => {
      console.error("PostRelatedPerson", error);
      // toast.error(`PostRelatedPerson Error: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
